import React from 'react';
import Button from '../../core/components/Button/component.js';
import { ButtonVariant } from '../../core/components/Button/types.js';
import { Modal } from '../../core/components/Modal/component.js';

var ConfirmationModal = function ConfirmationModal(props) {
  var _props$cancelButtonTe = props.cancelButtonText,
      cancelButtonText = _props$cancelButtonTe === void 0 ? 'Cancel' : _props$cancelButtonTe,
      children = props.children,
      confirmButtonDisabled = props.confirmButtonDisabled,
      _props$confirmButtonT = props.confirmButtonText,
      confirmButtonText = _props$confirmButtonT === void 0 ? 'Okay' : _props$confirmButtonT,
      _props$confirmOnly = props.confirmOnly,
      confirmOnly = _props$confirmOnly === void 0 ? false : _props$confirmOnly,
      data = props.data,
      header = props.header,
      _props$id = props.id,
      id = _props$id === void 0 ? 'confirmation-modal' : _props$id,
      _props$modalType = props.modalType,
      modalType = _props$modalType === void 0 ? 'modal' : _props$modalType,
      onCancel = props.onCancel,
      onClose = props.onClose,
      onConfirm = props.onConfirm,
      show = props.show,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      title = props.title,
      variant = props.variant;

  var closeWithConfirm = function closeWithConfirm(e) {
    if (onConfirm) {
      onConfirm(props.data, e);
    }
  };

  var coreFooter = /*#__PURE__*/React.createElement(React.Fragment, null, !confirmOnly && /*#__PURE__*/React.createElement(Button, {
    "data-action": "cancel",
    id: "".concat(id, "-cancel-button"),
    onClick: onCancel,
    variant: ButtonVariant.OUTLINE
  }, cancelButtonText), /*#__PURE__*/React.createElement(Button, {
    "data-action": "confirm",
    disabled: confirmButtonDisabled,
    id: "".concat(id, "-confirm-button"),
    onClick: closeWithConfirm,
    variant: ButtonVariant.PRIMARY
  }, confirmButtonText));
  return /*#__PURE__*/React.createElement(Modal, {
    footer: coreFooter,
    header: header || title,
    id: id,
    isOpen: show === undefined ? !!data : show,
    modalType: modalType,
    onClose: onClose,
    showCloseButton: false,
    size: size,
    variant: variant
  }, children);
};

ConfirmationModal.displayName = "ConfirmationModal";
export { ConfirmationModal, ConfirmationModal as default };